export default __webpack_public_path__ + "static/media/salary1.781bc134.png";